export default __webpack_public_path__ + "static/content-3ee2319896dc3c0514918666c7ccb82a.jpg";